import React from "react";

import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import DesktopWindowsOutlinedIcon from "@material-ui/icons/DesktopWindowsOutlined";

import ThriveSignaturegep from "assets/img/Thrive Signaturegep.png";

import { useHistory } from "react-router-dom";

import landinglogo from "assets/img/hs_landing.png";
import bannerImage from "assets/img/landingbanner.png";

export default function ThriveSignatureConfirmation({
  setNext,
  signatureData,
}) {
  const enrollmentData = {
    practiceName:
      signatureData?.practice_name ||
      signatureData?.practiceName ||
      "",

    practiceOwner:
      `${signatureData?.ownerfirstname || ""} ${
        signatureData?.ownerlastname || ""
      }`.trim(),

    pointOfContact: {
      name:
        `${signatureData?.contactfirstname || ""} ${
          signatureData?.contactlastname || ""
        }`.trim(),

      role: "Office Manager",
      phone: signatureData?.officenumber || "",
      email: signatureData?.customeremail || "",
    },

    subscriptionPlan: signatureData?.subscription_plan
      ? `${signatureData.subscription_plan} Plan`
      : "",

    price:
      signatureData?.subscription_plan === "Monthly"
        ? "$115 per month"
        : signatureData?.subscription_plan === "Yearly"
        ? "$1,299 per year"
        : "",

    commitment:
      signatureData?.subscription_plan === "Yearly" ? (
        <>
          Includes annual preventive
          <br />
          maintenance (labor only).
          <br />
          Yearly commitment required.
        </>
      ) : (
        <>No commitment required.</>
      ),

    promoCode: signatureData?.promo_code || "None",

    agreement: (
      <>
        Thrive Signature Service Agreement
        <br />
        and Terms and Conditions
        <br />
        Electronically signed on{" "}
        {new Date().toLocaleDateString("en-US")}
      </>
    ),
  };

  const history = useHistory();

  const handleReturn = () => {
  window.location.href = signatureData?.geplink || "";
};

  return (
    <>
      <style>{confirmationCss}</style>

      <div className="confirmation-page">

        {/* =====================================================
            TOP BANNER
        ===================================================== */}

        <div className="top-banner">

          <img
            src={bannerImage}
            alt="Thrive Signature"
            className="top-banner-image"
          />

          <div className="confirmation-banner-content">

            <div className="confirmation-brand">

              <img
                src={landinglogo}
                alt="Henry Schein"
                className="confirmation-hs-logo"
              />

              {/*
              If Thrive logo is required in banner, uncomment:

              <img
                src={sidelogo}
                alt="Thrive"
                className="confirmation-thrive-logo"
              />
              */}

            </div>

            <div className="confirmation-banner-divider" />

            <div className="confirmation-tagline">
              Save More. Do More. <span>Thrive.</span>
            </div>

            <div className="confirmation-banner-right">
              A HEALTHIER PRACTICE
              <br />
              A BRIGHTER TOMORROW
            </div>

          </div>
        </div>


        {/* =====================================================
            MAIN CARD
        ===================================================== */}

        <div className="confirmation-card">

          {/* PROGRESS STEPS */}

          <div className="confirmation-steps">

            <ConfirmationStep
              number="✓"
              title="Check Eligibility"
              completed
            />

            <div className="confirmation-step-line completed" />

            <ConfirmationStep
              number="✓"
              title="Review & Accept"
              completed
            />

            <div className="confirmation-step-line completed" />

            <ConfirmationStep
              number="3"
              title="Confirmation"
              active
            />

          </div>


          {/* SUCCESS */}

          <div className="success-section">

            <div className="success-circle">
              <CheckCircleIcon />
            </div>

            <h1>You're all set!</h1>

            <h2>
              Your Thrive Signature enrollment has been submitted.
            </h2>

            <p>
              Thank you for upgrading to Thrive Signature. A confirmation
              email with your enrollment{' '}
              <br className="desktop-break" />
              details and next steps will be sent shortly.
            </p>

          </div>


          {/* =====================================================
              ENROLLMENT SUMMARY
          ===================================================== */}

          <div className="summary-card">

            <div className="summary-header">

              {/* LEFT */}

              <div className="summary-header-content">

                <h2>Enrollment Summary</h2>

                <p>
                  A copy of this information will be included in your
                  confirmation email.
                </p>

              </div>


              {/* RIGHT - IMAGE */}

              <div className="summary-logo">

                <img
                  src={ThriveSignaturegep}
                  alt="Henry Schein"
                />

              </div>

            </div>

            <div className="summary-divider" />


            {/* SUMMARY BODY */}

            <div className="summary-body">

              {/* LEFT COLUMN */}

              <div className="summary-column left-column">

                <SummaryRow
                  label="Practice Name"
                  value={enrollmentData.practiceName}
                />

                <SummaryRow
                  label="Practice Owner"
                  value={enrollmentData.practiceOwner}
                />

                <div className="summary-row poc-row">

                  <div className="summary-label">
                    Point of Contact
                  </div>

                  <div className="summary-value poc-value">

                    <div>
                      {enrollmentData.pointOfContact.name}
                    </div>

                    <div>
                      {enrollmentData.pointOfContact.role}
                    </div>

                    <div>
                      {enrollmentData.pointOfContact.phone}
                    </div>

                    <div>
                      {enrollmentData.pointOfContact.email}
                    </div>

                  </div>

                </div>

              </div>


              {/* VERTICAL LINE */}

              <div className="summary-vertical-line" />


              {/* RIGHT COLUMN */}

              <div className="summary-column right-column">

                <div className="summary-row">

                  <div className="summary-label">
                    Subscription Plan
                  </div>

                  <div className="summary-value">

                    <strong>
                      {enrollmentData.subscriptionPlan}
                    </strong>

                    <br />

                    <span>
                      {enrollmentData.price}
                    </span>

                    <br />

                    <span>
                      {enrollmentData.commitment}
                    </span>

                  </div>

                </div>


                <SummaryRow
                  label="Promo Code"
                  value={enrollmentData.promoCode}
                />


                <div className="summary-row">

                  <div className="summary-label">
                    Agreement
                  </div>

                  <div className="summary-value agreement-value">
                    {enrollmentData.agreement}
                  </div>

                </div>


                {/* STATUS */}

                <div className="summary-row status-row">

                  <div className="summary-label">
                    Status
                  </div>

                  <div className="summary-value">

                    <div className="submitted-badge">

                      <CheckCircleIcon />

                      <span>
                        Enrollment Submitted
                      </span>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>


          {/* =====================================================
              WHAT HAPPENS NEXT
          ===================================================== */}

          <div className="next-section">

            <h2>What happens next?</h2>

            <div className="next-cards">

              <NextStep
                icon={<EmailOutlinedIcon />}
                number="1."
                title="Confirmation Email"
              >
                You'll receive an email shortly with your enrollment
                confirmation and a copy of your agreement.
              </NextStep>


              <NextStep
                icon={<PeopleOutlineIcon />}
                number="2."
                title="Account Activation"
              >
                Your Thrive Signature benefits will be activated and
                available in your account soon.
              </NextStep>


              <NextStep
                icon={<DesktopWindowsOutlinedIcon />}
                number="3."
                title="Start Exploring"
              >
                Once activated, log in to your Henry Schein Dental account
                to explore all of your Thrive Signature benefits and
                resources.
              </NextStep>

            </div>

          </div>


          {/* =====================================================
              BOTTOM BUTTON
          ===================================================== */}

          <div className="confirmation-bottom">

            <button
              type="button"
              className="return-button"
              onClick={handleReturn}
            >
              Return to Henry Schein Dental
            </button>

          </div>

        </div>

      </div>
    </>
  );
}


/* =========================================================
   PROGRESS STEP
========================================================= */

const ConfirmationStep = ({
  number,
  title,
  completed = false,
  active = false,
}) => {
  return (
    <div
      className={`confirmation-step ${
        completed || active ? "active" : ""
      }`}
    >

      <div className="confirmation-step-circle">
        {number}
      </div>

      <div className="confirmation-step-title">
        {title}
      </div>

    </div>
  );
};


/* =========================================================
   SUMMARY ROW
========================================================= */

const SummaryRow = ({ label, value }) => {
  return (
    <div className="summary-row">

      <div className="summary-label">
        {label}
      </div>

      <div className="summary-value">
        {value}
      </div>

    </div>
  );
};


/* =========================================================
   NEXT STEP CARD
========================================================= */

const NextStep = ({
  icon,
  number,
  title,
  children,
}) => {
  return (
    <div className="next-step">

      <div className="next-icon">
        {icon}
      </div>

      <div className="next-title">
        {number} {title}
      </div>

      <div className="next-description">
        {children}
      </div>

    </div>
  );
};


/* =========================================================
   CSS
========================================================= */

const confirmationCss = `

* {
  box-sizing: border-box;
}


/* =========================================================
   PAGE
========================================================= */

.confirmation-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;

  background: #ffffff;

  font-family: Arial, Helvetica, sans-serif;

  color: #1638ca;

  overflow-x: hidden;
}


/* =========================================================
   TOP BANNER
========================================================= */

.top-banner {
  width: 100%;
  height: 110px;

  position: relative;

  overflow: hidden;

  background: none;
}

.top-banner-image {
  position: absolute;

  inset: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;

  z-index: 0;
}

.confirmation-banner-content {
  width: 100%;
  max-width: 760px;

  height: 68px;

  margin: 0 auto;

  padding: 0 0 0 28px;

  position: relative;

  z-index: 2;

  display: flex;

  align-items: center;

  gap: 12px;

  flex-wrap: nowrap;
}


/* =========================================================
   BRAND
========================================================= */

.confirmation-brand {
  display: flex;

  flex-direction: column;

  align-items: flex-start;

  flex-shrink: 0;
}

.confirmation-hs-logo {
  width: 105px;

  height: auto;

  object-fit: contain;
}

.confirmation-thrive-logo {
  width: 104px;

  height: auto;

  margin-top: -2px;

  object-fit: contain;

  flex-shrink: 0;
}

.confirmation-banner-divider {
  width: 1px;

  height: 38px;

  background: #A9BFD8;

  flex-shrink: 0;
}

.confirmation-tagline {
  color: #1638CA;

  font-size: 17px;

  line-height: 22px;

  font-weight: 700;

  white-space: nowrap;

  flex-shrink: 0;
}

.confirmation-tagline span {
  color: #2F9BE8;
}

.confirmation-banner-right {
  margin-left: auto;

  color: #1744d8;

  font-size: 8px;

  line-height: 11px;

  font-weight: 800;

  letter-spacing: 0.6px;

  text-align: right;

  white-space: nowrap;

  flex-shrink: 0;
}


/* =========================================================
   MAIN CARD
========================================================= */

.confirmation-card {
  width: calc(100% - 40px);

  max-width: 1000px;

  margin: -36px auto 32px;

  padding: 22px 32px 26px;

  position: relative;

  z-index: 5;

  background: rgba(255, 255, 255, 0.98);

  border: 1px solid #dceaf8;

  border-radius: 8px;

  box-shadow:
    0 5px 20px rgba(28, 119, 206, 0.15);
}


/* =========================================================
   STEPS
========================================================= */

.confirmation-steps {
  width: 100%;

  display: flex;

  align-items: flex-start;

  justify-content: center;

  margin: 0 auto 20px;
}

.confirmation-step {
  width: 150px;

  flex-shrink: 0;

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;
}

.confirmation-step-circle {
  width: 28px;

  height: 28px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #e9effb;

  border: 1px solid #cbd9f1;

  color: #7185c2;

  font-size: 13px;

  font-weight: 700;
}

.confirmation-step.active
.confirmation-step-circle {
  background: #1677e8;

  border-color: #1677e8;

  color: #ffffff;

  box-shadow:
    0 2px 5px rgba(20, 112, 229, 0.22);
}

.confirmation-step-title {
  margin-top: 6px;

  color: #1b43cf;

  font-size: 12px;

  line-height: 15px;

  font-weight: 600;

  white-space: nowrap;
}

.confirmation-step-line {
  width: 110px;

  height: 1px;

  margin-top: 14px;

  background: #d2def1;
}

.confirmation-step-line.completed {
  background: #4c9aee;
}


/* =========================================================
   SUCCESS
========================================================= */

.success-section {
  text-align: center;

  margin: 0 auto 20px;
}

.success-circle {
  width: 70px;

  height: 70px;

  margin: 0 auto 10px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #dff3e4;

  box-shadow:
    0 0 0 8px rgba(91, 174, 105, 0.08);
}

.success-circle svg {
  width: 48px;

  height: 48px;

  color: #4a9e5d;
}

.success-section h1 {
  margin: 0 0 4px;

  color: #1026c9;

  font-size: 32px;

  line-height: 37px;

  font-weight: 700;
}

.success-section h2 {
  margin: 0 0 10px;

  color: #1238d4;

  font-size: 18px;

  line-height: 23px;

  font-weight: 600;
}

.success-section p {
  margin: 0 auto;

  max-width: 560px;

  color: #7182b5;

  font-size: 13px;

  line-height: 18px;

  font-weight: 400;
}


/* =========================================================
   SUMMARY CARD
========================================================= */

.summary-card {
  width: 100%;

  padding: 18px 24px 18px;

  border: 1px solid #d9e8fa;

  border-radius: 6px;

  background:
    linear-gradient(
      180deg,
      #ffffff,
      #fbfdff
    );

  box-shadow:
    0 2px 8px rgba(45, 130, 220, 0.06);

  margin-bottom: 18px;
}


/* =========================================================
   SUMMARY HEADER
========================================================= */

.summary-header {
  width: 100%;

  display: flex;

  align-items: flex-start;

  justify-content: space-between;

  gap: 10px;
}

.summary-header-content {
  flex: 1;

  min-width: 0;
}

.summary-header h2 {
  margin: 0 0 4px;

  color: #102bc9;

  font-size: 19px;

  line-height: 23px;

  font-weight: 700;
}

.summary-header p {
  margin: 0;

  color: #7b8bb7;

  font-size: 11px;

  line-height: 15px;
}


/* =========================================================
   SUMMARY LOGO
========================================================= */

.summary-logo {
  display: flex;

  flex-direction: column;

  align-items: flex-end;

  margin-right: 3px;

  margin-left: auto;

  flex-shrink: 0;
}

.summary-logo img {
  width: 100px;

  height: auto;

  object-fit: contain;

  display: block;
}

.summary-thrive {
  margin-top: -6px;

  color: #0785ed;

  font-size: 30px;

  line-height: 29px;

  font-weight: 700;

  letter-spacing: -1.2px;
}

.summary-thrive span {
  display: block;

  text-align: right;

  margin-left: 3px;

  color: #1473db;

  font-size: 10px;

  line-height: 11px;

  letter-spacing: 0;
}

.summary-divider {
  width: 100%;

  height: 1px;

  margin: 14px 0 16px;

  background: #e1eaf6;
}


/* =========================================================
   SUMMARY BODY
========================================================= */

.summary-body {
  width: 100%;

  display: grid;

  grid-template-columns:
    1fr
    1px
    1fr;

  column-gap: 32px;
}

.summary-vertical-line {
  width: 1px;

  background: #dce7f4;
}


/* =========================================================
   SUMMARY ROW
========================================================= */

.summary-row {
  width: 100%;

  display: grid;

  grid-template-columns:
    135px
    1fr;

  column-gap: 10px;

  margin-bottom: 16px;

  align-items: flex-start;
}

.summary-label {
  color: #2441a3;

  font-size: 12px;

  line-height: 16px;

  font-weight: 700;
}

.summary-value {
  color: #6073a9;

  font-size: 12px;

  line-height: 17px;

  font-weight: 400;
}

.summary-value strong {
  color: #52699f;

  font-weight: 700;
}

.poc-row {
  margin-bottom: 0;
}

.poc-value {
  line-height: 17px;
}


/* =========================================================
   AGREEMENT
========================================================= */

.agreement-value {
  color: #52689f;

  line-height: 17px;
}


/* =========================================================
   STATUS
========================================================= */

.status-row {
  margin-top: 2px;

  margin-bottom: 0;
}

.submitted-badge {
  min-height: 30px;

  padding: 5px 12px;

  display: inline-flex;

  align-items: center;

  gap: 6px;

  border-radius: 5px;

  background: #e4f4e7;

  color: #3b9650;

  font-size: 12px;

  line-height: 15px;

  font-weight: 700;
}

.submitted-badge svg {
  width: 19px;

  height: 19px;

  color: #4ca05d;
}


/* =========================================================
   WHAT HAPPENS NEXT
========================================================= */

.next-section {
  width: 100%;

  margin-bottom: 14px;

  border-radius: 6px;

  background:
    linear-gradient(
      90deg,
      #f2faff,
      #edf8ff
    );

  padding: 16px 0 20px;
}

.next-section > h2 {
  margin: 0 0 14px;

  text-align: center;

  color: #102bc9;

  font-size: 19px;

  line-height: 23px;

  font-weight: 700;
}


/* =========================================================
   NEXT CARDS
========================================================= */

.next-cards {
  width: 100%;

  display: grid;

  grid-template-columns:
    1fr
    1fr
    1fr;
}

.next-step {
  min-height: 150px;

  padding: 6px 24px 8px;

  text-align: center;

  border-right: 1px solid #b8dff8;
}

.next-step:last-child {
  border-right: none;
}


/* =========================================================
   NEXT ICON
========================================================= */

.next-icon {
  width: 50px;

  height: 50px;

  margin: 0 auto 8px;

  border-radius: 50%;

  display: flex;

  align-items: center;

  justify-content: center;

  background: #d9efff;

  color: #126de2;
}

.next-icon svg {
  width: 28px;

  height: 28px;
}


/* =========================================================
   NEXT TITLE
========================================================= */

.next-title {
  color: #173bb8;

  font-size: 13px;

  line-height: 17px;

  font-weight: 700;

  margin-bottom: 5px;
}

.next-description {
  color: #6d7fae;

  font-size: 11.5px;

  line-height: 16px;

  max-width: 200px;

  margin: 0 auto;
}


/* =========================================================
   BOTTOM
========================================================= */

.confirmation-bottom {
  width: 100%;

  padding-top: 14px;

  border-top: 1px solid #dce8f6;

  display: flex;

  justify-content: center;
}

.return-button {
  width: 340px;

  height: 42px;

  border: none;

  border-radius: 5px;

  background: #0879ed;

  color: #ffffff;

  font-family: Arial, Helvetica, sans-serif;

  font-size: 13px;

  line-height: 17px;

  font-weight: 700;

  cursor: pointer;

  box-shadow:
    0 2px 5px rgba(0, 100, 220, 0.18);

  transition:
    background 0.15s ease;
}

.return-button:hover {
  background: #066bd3;
}


/* =========================================================
   TABLET
========================================================= */

@media only screen and (max-width: 900px) {

  .confirmation-banner-content {
    padding: 8px 16px;
  }

  .confirmation-card {
    width: calc(100% - 24px);

    margin-top: -10px;

    padding: 18px 20px 20px;
  }

  .summary-body {
    column-gap: 20px;
  }

  .summary-row {
    grid-template-columns:
      115px
      1fr;
  }

  .next-step {
    padding: 6px 14px;
  }
}


/* =========================================================
   MOBILE
========================================================= */

@media only screen and (max-width: 600px) {


  /* =======================================================
     TOP BANNER
  ======================================================= */

  .top-banner {
    width: 100%;

    height: 110px;

    overflow: hidden;
  }

  .top-banner-image {
    width: 100%;

    height: 100%;

    object-fit: cover;
  }

  .confirmation-banner-content {
    width: 100%;

    max-width: none;

    height: 68px;

    margin: 0;

    padding: 0 10px 0 14px;

    display: flex;

    align-items: center;

    gap: 8px;

    flex-wrap: nowrap;

    overflow: hidden;
  }

  .confirmation-brand {
    display: flex;

    flex-direction: column;

    align-items: flex-start;

    flex-shrink: 0;

    white-space: nowrap;
  }

  .confirmation-hs-logo {
    width: 70px;

    height: auto;

    flex-shrink: 0;
  }

  .confirmation-thrive-logo {
    width: 84px;

    height: auto;

    margin-top: -2px;

    flex-shrink: 0;
  }

  .confirmation-banner-divider {
    width: 1px;

    height: 30px;

    flex-shrink: 0;
  }

  .confirmation-tagline {
    color: #1638CA;

    font-size: 12px;

    line-height: 15px;

    font-weight: 700;

    white-space: nowrap;

    flex-shrink: 0;
  }

  .confirmation-banner-right {
    margin-left: auto;

    color: #1744d8;

    font-size: 6px;

    line-height: 8px;

    letter-spacing: 0.3px;

    text-align: right;

    white-space: nowrap;

    flex-shrink: 0;
  }


  /* =======================================================
     MAIN CARD
  ======================================================= */

  .confirmation-card {
    width: calc(100% - 14px);

    margin: -8px auto 18px;

    padding: 14px 12px 16px;
  }


  /* =======================================================
     STEPS
  ======================================================= */

  .confirmation-steps {
    margin-bottom: 14px;
  }

  .confirmation-step {
    width: 80px;
  }

  .confirmation-step-circle {
    width: 22px;

    height: 22px;

    font-size: 10px;
  }

  .confirmation-step-title {
    font-size: 8px;

    line-height: 10px;
  }

  .confirmation-step-line {
    width: 38px;

    margin-top: 11px;
  }


  /* =======================================================
     SUCCESS
  ======================================================= */

  .success-circle {
    width: 54px;

    height: 54px;

    margin-bottom: 7px;
  }

  .success-circle svg {
    width: 38px;

    height: 38px;
  }

  .success-section h1 {
    font-size: 22px;

    line-height: 26px;
  }

  .success-section h2 {
    font-size: 13px;

    line-height: 17px;
  }

  .success-section p {
    font-size: 10px;

    line-height: 14px;
  }

  .desktop-break {
    display: none;
  }


  /* =======================================================
     SUMMARY CARD
  ======================================================= */

  .summary-card {
    padding: 12px;

    margin-bottom: 12px;
  }


  /* =======================================================
     SUMMARY HEADER
     
     IMPORTANT:
     Image stays at TOP-RIGHT on mobile.
     It will NOT move below the text.
  ======================================================= */

  .summary-header {
    width: 100%;

    display: flex;

    flex-direction: row;

    align-items: flex-start;

    justify-content: space-between;

    gap: 8px;
  }

  .summary-header-content {
    flex: 1;

    min-width: 0;
  }

  .summary-header h2 {
    font-size: 14px;

    line-height: 18px;

    margin: 0 0 4px;
  }

  .summary-header p {
    font-size: 8.5px;

    line-height: 11px;
  }


  /* =======================================================
     SUMMARY IMAGE
  ======================================================= */

  .summary-logo {
    display: flex;

    flex-direction: column;

    align-items: flex-end;

    justify-content: flex-start;

    margin-left: auto;

    margin-right: 0;

    flex-shrink: 0;
  }

  .summary-logo img {
    width: 56px;

    height: auto;

    display: block;

    object-fit: contain;
  }


  /* =======================================================
     SUMMARY DIVIDER
  ======================================================= */

  .summary-divider {
    margin: 8px 0 10px;
  }


  /* =======================================================
     SUMMARY BODY
  ======================================================= */

  .summary-body {
    grid-template-columns: 1fr;

    column-gap: 0;

    row-gap: 14px;
  }

  .summary-vertical-line {
    width: 100%;

    height: 1px;
  }

  .summary-row {
    grid-template-columns:
      100px
      1fr;

    column-gap: 6px;

    margin-bottom: 10px;
  }

  .summary-label {
    font-size: 9.5px;

    line-height: 13px;
  }

  .summary-value {
    font-size: 9.5px;

    line-height: 13px;
  }

  .poc-value {
    line-height: 13px;
  }

  .agreement-value {
    line-height: 13px;
  }


  /* =======================================================
     STATUS
  ======================================================= */

  .submitted-badge {
    min-height: 22px;

    padding: 3px 8px;

    gap: 3px;

    font-size: 9px;

    line-height: 11px;
  }

  .submitted-badge svg {
    width: 13px;

    height: 13px;
  }


  /* =======================================================
     NEXT SECTION
  ======================================================= */

  .next-section {
    padding: 10px 0 12px;
  }

  .next-section > h2 {
    font-size: 14px;

    line-height: 18px;

    margin-bottom: 8px;
  }

  .next-cards {
    grid-template-columns: 1fr;
  }

  .next-step {
    min-height: 0;

    padding: 10px 14px;

    border-right: none;

    border-bottom: 1px solid #b8dff8;
  }

  .next-step:last-child {
    border-bottom: none;
  }

  .next-icon {
    width: 36px;

    height: 36px;

    margin-bottom: 5px;
  }

  .next-icon svg {
    width: 20px;

    height: 20px;
  }

  .next-title {
    font-size: 9.5px;

    line-height: 12px;

    margin-bottom: 3px;
  }

  .next-description {
    font-size: 8.5px;

    line-height: 11px;
  }


  /* =======================================================
     BUTTON
  ======================================================= */

  .confirmation-bottom {
    padding-top: 10px;
  }

  .return-button {
    width: 90%;

    height: 36px;

    font-size: 10px;
  }
}

`;